<template>
  <a-layout class='index animated fadeIn'>
    <SmallSquare content='显示总部代发订单和权益卡按角色比例分配订单的分账比例和金额' :padding='true'></SmallSquare>
    <a-card :bordered='false'>
      <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="" name='keyword'>
          <a-input-group compact :style="{width:'370px'}">
            <a-select v-model:value="search.key_type" style="width: 35%" @change="search.keyword=''">
              <a-select-option value="order_no">订单号</a-select-option>
              <a-select-option value="product_name">商品名称</a-select-option>
              <a-select-option value="dealer_name">经销商名称</a-select-option>
              <a-select-option value="store_name">门店名称</a-select-option>
            </a-select>
            <a-input style="width: 65%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
          </a-input-group>
        </a-form-item>
        <a-form-item label="签收时间" name=''>
          <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
        </a-form-item>
        <a-form-item label="商品类型" name='order_product_type'>
          <a-select class='m-r-10' v-model:value="search.order_product_type" :style="{width:'140px'}" placeholder="请选择">
            <a-select-option value="">全部订单</a-select-option>
            <a-select-option :value="1">代发商品</a-select-option>
            <a-select-option :value="2">权益卡</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" ghost @click="exportTable">导出</a-button>
        </a-form-item>
      </a-form>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='order_no' :columns='columns' :data-source='data'>
        <template v-slot:store_money="{record}">
          <p>{{record.store_name}}</p>
          {{record.store_money}}
        </template>
        <template v-slot:dealer_money="{record}">
          <p>{{record.dealer_name}}</p>
          {{record.dealer_money}}
        </template>
        <template v-slot:action="{ record }">
          <a-button type="link" v-has:orderHeadOnbehalfDetail="()=>{showMore=true;order_id=record.id}">查看详情</a-button>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数:${total} `" />
    </a-card>
    <a-modal  :keyboard="false" title="查看明细" :width='1300' centered :footer="null" v-model:visible="showMore" destroyOnClose>
      <headOnbehalfMore :id='order_id'></headOnbehalfMore>
    </a-modal>
  </a-layout>
</template>
<script>
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { getRouter } from "@/utils/app";
import { setPageState, getPageState } from "@/utils/pageState";
import { getOrderInsteadShip } from "@/api/order";
import { iscode } from "@/utils/app";
import store from "@/store"
import headOnbehalfMore from './components/headOnbehalfMore'
// 初始化默认筛选项数值
let defSearch = {
  start_time: '',
  end_time: '',
  page: 1,
  limit: 10,
  key_type: "order_no",
  keyword: "",
  order_product_type:''
};
export default {
  components: { headOnbehalfMore },
  setup(props, ctx) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref([]);
    const state = reactive({
      listLoading: false,
      time: [],
      total: 1,
      showMore: false,
      order_id:''
    });
    let columns = [
      {
        title: "订单号",
        dataIndex: "order_no",
        key: "order_no",
      },
      {
        title: "商品类型",
        dataIndex: "order_product_type_text",
        key: "order_product_type_text",
      },
      {
        title: "下单时间",
        dataIndex: "order_time",
        key: "order_time",
        customRender: ({ record }) => {
          return  record.order_time?record.order_time:'-'
        }
      },
      {
        title: "签收时间",
        dataIndex: "settle_time",
        key: "settle_time",
      },
        {
        title: "分账总金额",
        dataIndex: "split_price",
        key: "split_price",
      },
      {
        title: "经销商分账金额",
        dataIndex: "dealer_money",
        key: "dealer_money",
        slots: { customRender: "dealer_money" },
      },
         {
        title: "门店分账金额",
        dataIndex: "store_money",
        key: "store_money",
        slots: { customRender: "store_money" },
      },
      {
        title: "商品一级/自购佣金金额",
        dataIndex: "distribute_first_money",
        key: "distribute_first_money",
      },
      {
        title: "商品二级佣金",
        dataIndex: "distribute_second_money",
        key: "distribute_second_money",
      },
      {
        title: "操作",
        key: "action",
        align:'center',
        slots: { customRender: "action" },
      },
    ];
    const $route = inject("$route");
    const $router = inject("$router");
    const $Modal = inject("$Modal");

    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    const onChange = (e) => {
      search.value.start_time = e[0];
      search.value.end_time = e[1];
    }
    const initData = async (values) => {
      state.listLoading = true;
      try {
        let res = await getOrderInsteadShip(values).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };
    onMounted(() => {
      // 查看是否有留存状态，有则替换
      let pageState = getPageState(getRouter().route.path);
      if (pageState) {
        search.value = Object.assign(search.value, pageState);
      }
      initData();
    });
    // 导出
    const exportTable = async () => {
      let res = await getOrderInsteadShip({ ...search.value, is_excel: 1 }).then(
        (res) => res.data
      );
      if (iscode(res, true)) {
        window.open(res.data.action);
      }
    };
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      exportTable,
      info: store.state.user.info,
      onChange
    };
  },
};
</script>